import LinearProgress from '@mui/material/LinearProgress';
import { GridContainer } from './ProgressBar.Styled';

const ProgressBar = () => {
  return (
    <GridContainer>
      <LinearProgress />
    </GridContainer>
  );
};

export default ProgressBar;
